import React from 'react';
import strings from 'utils/strings';
import AlertBox from 'components/CreateNotification/alert';
import deleteSubTestResult from 'api/deleteSubTestResult';

class DeleteSubTestModel extends React.Component {
	constructor(props) {
		super(props);

		// Extract testKey from selectedTestUser array
		const [{key = null} = {}] = this.props.selectedTestUser || [];

		// selectedId is an array of selected subtest objects → e.g. [ {id: 123, ...} ]
		const selectedObj = this.props.selectedId?.[0] || {};

		this.state = {
			selectedObjId: selectedObj.id || null,
			testKey: key,
			showAlert: false,
			success: null,
			message: '',
			isConfirmedDisabled: false,
		};
	}

	//----------------------------------------------------
	// CONFIRM → SEND DELETE REQUEST
	//----------------------------------------------------
	onConfirm = () => {
		const {selectedObjId, testKey} = this.state;

		if (!selectedObjId) {
			this.setState({
				showAlert: true,
				success: false,
				message: strings.invalidSubtestSelection,
			});
			return;
		}

		this.setState({isConfirmedDisabled: true});

		deleteSubTestResult({
			subtestId: selectedObjId,
			testKey: testKey,
		}).then((res) => {
			if (!res || res.error) {
				this.setState({
					showAlert: true,
					success: false,
					message: strings.opsSomethingWentWrongCap,
				});
			} else {
				this.props.getTestsBySearch({testKey});

				this.setState({
					showAlert: true,
					success: true,
					message: strings.subtestDeletedSuccessfully,
				});
			}

			setTimeout(() => {
				this.setState({showAlert: false});
				this.props.onDeleteModelConfirm();
			}, 3000);
		});
	};

	//----------------------------------------------------
	// CANCEL MODAL
	//----------------------------------------------------
	onCancel = () => {
		this.props.onDeleteModelCancel();
		this.setState({
			showAlert: false,
			success: null,
			message: '',
		});
	};

	//----------------------------------------------------
	// RENDER UI
	//----------------------------------------------------
	render() {
		const {showAlert, message, success} = this.state;

		return (
			<div
				className="lit-modal"
				onClick={() => this.props.onDeleteModelCancel()}
			>
				<div
					className="lit-modal__other"
					onClick={(event) => event.stopPropagation()}
				>
					<h3>{strings.deleteSubtest}</h3>

					<p style={{marginBottom: '15px'}}>
						{strings.warningDeleteSubtest}
					</p>

					<div className="lit-post-notification-btn-div">
						<button
							className="lit-btn bg-primary"
							onClick={this.onConfirm}
						>
							{strings.confirm}
						</button>

						<button
							className="lit-btn bg-negative"
							onClick={this.onCancel}
						>
							{strings.cancel}
						</button>
					</div>

					{showAlert && (
						<AlertBox
							type={success ? 'success' : 'error'}
							message={message}
						/>
					)}
				</div>
			</div>
		);
	}
}

export default DeleteSubTestModel;
